import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  TextField,
} from "@mui/material";
import { useEffect } from "react";
import apiService from "services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "state";

export default function ProductFilterForm({
  isLoading,
  fetchingError = () => {},
}) {
  const [nomenclatureFilters, setNomenclatureFilters] = useState([]);
  const [marqueModeleFilters, setMarqueModeleFilters] = useState([]);
  const [otherFilters, setOtherFilters] = useState([]);
  const filters = useSelector((state) => state.filters);
  const [form, setForm] = useState(filters);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchFilters = async () => {
      const { data, error } = await apiService.fetchData("/atemo/filters");
      if (error) {
        console.error("Error fetching filters:", error);
        fetchingError(error);
        return;
      }

      if (data && data.nomenclature) {
        setNomenclatureFilters(data.nomenclature);
      }
      if (data && data.marqueModele) {
        setMarqueModeleFilters(data.marqueModele);
      }
      if (data && data.other) {
        setOtherFilters(data.other);
      }
    };
    fetchFilters();
  }, []);

  const handleChange = (field, value) => {
    const key = typeof field === "string" ? field : field.key;
    const isMultiple = typeof field === "object" && field.multiple;

    if (key === "CodeFamille") {
      setForm({
        ...form,
        CodeFamille: value?.value,
        CodeSousFamille: null,
        CodeTypePiece: null,
      });
      return;
    } else if (key === "CodeSousFamille") {
      setForm({
        ...form,
        CodeSousFamille: value?.value,
        CodeTypePiece: null,
      });
      return;
    } else if (key === "MarqueVEH") {
      setForm({
        ...form,
        MarqueVEH: value?.value,
        ModeleVEH: null,
        Phase: null,
      });
      return;
    } else if (key === "ModeleVEH") {
      setForm({
        ...form,
        ModeleVEH: value?.value,
        Phase: null,
      });
    }
    if (isMultiple) {
      const values = value.map((v) => v.value);
      if (values.length === 0) {
        setForm({ ...form, [key]: null });
        return;
      }
      setForm({ ...form, [key]: values });
      return;
    }
    setForm({ ...form, [key]: value?.value || value });
  };

  const handleSubmit = () => {
    //onSubmit(form);
    dispatch(setFilters({ filters: form }));
  };

  const filterComponent = (filter, filterData) => {
    if (filter.type === "select") {
      let options = filterData[filter.key];
      if (filter.key === "CodeSousFamille") {
        options = options.filter((o) => o.CodeFamille === form["CodeFamille"]);
      } else if (filter.key === "CodeTypePiece") {
        options = options.filter(
          (o) =>
            o.CodeFamille === form["CodeFamille"] &&
            o.CodeSousFamille === form["CodeSousFamille"]
        );
      } else if (filter.key === "ModeleVEH") {
        options = options.filter((o) => o.MarqueVEH === form["MarqueVEH"]);
      } else if (filter.key === "Phase") {
        options = options.filter(
          (o) =>
            o.MarqueVEH === form["MarqueVEH"] &&
            o.ModeleVEH === form["ModeleVEH"]
        );
      }

      let value = options.find((o) => o.value === form[filter.key]) || null;
      if (filter.multiple) {
        value = options.filter((o) => form[filter.key]?.includes(o.value));
      }
      return (
        <Autocomplete
          key={filter.key}
          disablePortal
          multiple={filter.multiple || false}
          size="small"
          value={value}
          onChange={(_, newValue) => handleChange(filter, newValue)}
          options={options}
          noOptionsText="Aucune option"
          renderInput={(params) => (
            <TextField {...params} label={filter.label} />
          )}
          sx={{ minWidth: 150, flex: 1 }}
        />
      );
    } else if (filter.type === "text") {
      return (
        <FormControl key={filter.key} sx={{ minWidth: 150, flex: 1 }}>
          <TextField
            size="small"
            value={form[filter.key] || ""}
            label={filter.label}
            onChange={(event) => handleChange(filter, event.target.value)}
          />
        </FormControl>
      );
    }
    return null;
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        {nomenclatureFilters?.formStructure?.map((filter) => {
          return filterComponent(filter, nomenclatureFilters);
        })}

        {marqueModeleFilters?.formStructure?.map((filter) => {
          return filterComponent(filter, marqueModeleFilters);
        })}

        {otherFilters?.formStructure?.map((filter) => {
          return filterComponent(filter, otherFilters);
        })}
      </Box>
      <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" loading={isLoading} onClick={handleSubmit}>
          Charger les produits
        </Button>
      </Box>
    </Box>
  );
}
